import React, { useRef, useState, useEffect } from "react";
import Button from "../Button";

const WebcamCapture = ({ onPhotoTaken }) => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [photo, setPhoto] = useState(null);

  const startWebcam = () => {
    navigator.mediaDevices.getUserMedia({ video: true })
      .then((stream) => {
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
        }
      })
      .catch((err) => console.error("Erreur d'accès à la webcam :", err));
  };

  useEffect(() => {
    startWebcam();
    const videoEl = videoRef.current;
    return () => {
      // Nettoyage : arrêt du flux webcam quand le composant est démonté
      if (videoEl && videoEl.srcObject) {
        videoEl.srcObject.getTracks().forEach(track => track.stop());
      }
    };
  }, []);

  const takePhoto = () => {
    const canvas = canvasRef.current;
    const video = videoRef.current;
    const context = canvas.getContext("2d");

    context.drawImage(video, 0, 0, canvas.width, canvas.height);
    const imageDataUrl = canvas.toDataURL("image/jpeg", 0.85);
    setPhoto(imageDataUrl);
    onPhotoTaken(imageDataUrl); // Pass the image data to the parent component

    // Arrêter le flux webcam après la capture
    if (videoRef.current && videoRef.current.srcObject) {
        videoRef.current.srcObject.getTracks().forEach(track => track.stop());
    }
  };

  const resetPhoto = () => {
    setPhoto(null);
    onPhotoTaken(null); // Notify parent that photo is reset
    startWebcam();
  };

  return (
    <div className="webcam-capture">
      {!photo && (
        <>
            <video ref={videoRef} width="640" height="480" autoPlay />
            <Button onClick={takePhoto} variant="primary">Prendre une photo</Button>
            <canvas ref={canvasRef} width="640" height="480" style={{ display: "none" }} />
        </>
      )}
      {photo && (
        <>
            <img src={photo} alt="Capture" width="640" height="480" />
            <Button onClick={resetPhoto} variant="secondary">Reprendre la photo</Button>
        </>
        )}
    </div>
  );
};

export default WebcamCapture;